import { DOMNodeProps } from "@/types";
import { ReactNode } from "react";
import styles from "./TableHeader.module.scss";

export interface TableHeaderProps extends DOMNodeProps {
  left?: ReactNode;
  right?: ReactNode;
  noRoundedTop?: boolean;
}

export default function TableHeader({
  left,
  right,
  noRoundedTop = false,
  ...props
}: TableHeaderProps) {
  return (
    <div
      className={[styles.TableHeader, noRoundedTop ? styles["no-rounded-top"] : ""].join(" ")}
      {...props}
    >
      {left && <div className={styles.left}>{left}</div>}
      {right && <div className={styles.right}>{right}</div>}
    </div>
  );
}
